import { CustomHookProps, useBasicQuery } from '@napa/react-core';
import { User } from 'types/users';

export default function useBrowseUsers(props?: CustomHookProps<User>): any {
  return useBasicQuery<User>({
    apiRoute: 'users',
    httpMethod: 'GET',
    isFormData: false,
    body: undefined,
    queryId: 'browseUsers',
    params: props,
  });
}
